import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
  getCustomer,
  updateCustomer,
} from "../../../services/customer.services";
import { useLocation } from "react-router-dom";
import { setCustomerDetail } from "../../../state/reducers/customerSlice";

function CustomerProfileData() {
  const admins = useSelector((state) => state.admin.admins);
  const customerDetail = useSelector((state) => state.customer.customerDetail);
  const location = useLocation();
  const services = useSelector((state) => state.service);
  const [isSaving, setIsSaving] = useState(false);
  const [validationError, setValidationError] = useState("");

  // Get assigned admin for a specific service
  const getAssignedAdmin = (serviceName) => {
    const service = customerDetail?.services?.find(
      (s) => s.coreservice_name === serviceName
    );
    return service ? service.assigned_to : null;
  };

  const [formData, setFormData] = useState({
    ...customerDetail,
    assigned_abroad_counseling: getAssignedAdmin("Abroad Counseling"),
    assigned_career_counseling: getAssignedAdmin("Career Counseling"),
    assigned_test_preparation: getAssignedAdmin("Test Preparation"),
    assigned_visa: getAssignedAdmin("Other Services"),
    assigned_profile_building: getAssignedAdmin("Profile Building"),
  });

  const dispatch = useDispatch();
  const [isEditing, setIsEditing] = useState(false);

  const intakeOptions = [
    "Sept-2022",
    "January-2023",
    "Sept-2023",
    "Jan-2024",
    "Sept-2024",
    "Jan-2025",
    "Sept-2025",
    "Jan-2026",
    "Sept-2026",
  ];

  const studyAbroadCountries = [
    { value: "USA", label: "USA" },
    { value: "UK", label: "UK" },
    { value: "Canada", label: "Canada" },
    { value: "Australia", label: "Australia" },
    { value: "New Zealand", label: "New Zealand" },
    { value: "Dubai", label: "Dubai" },
    { value: "Ireland", label: "Ireland" },
    { value: "Germany", label: "Germany" },
    { value: "France", label: "France" },
    { value: "Sweden", label: "Sweden" },
    { value: "Singapore", label: "Singapore" },
    { value: "Other", label: "Other" },
  ];

  const monthOptions = [
    { value: "January", label: "January" },
    { value: "February", label: "February" },
    { value: "March", label: "March" },
    { value: "April", label: "April" },
    { value: "May", label: "May" },
    { value: "June", label: "June" },
    { value: "July", label: "July" },
    { value: "August", label: "August" },
    { value: "September", label: "September" },
    { value: "October", label: "October" },
    { value: "November", label: "November" },
    { value: "December", label: "December" },
  ];

  useEffect(() => {
    if (customerDetail) {
      const { intake } = customerDetail;
      let intakeMonth = "";
      let intakeYear = "";

      if (intake) {
        const intakeDate = new Date(intake);
        intakeMonth = intakeDate.toLocaleString("default", { month: "long" });
        intakeYear = intakeDate.getFullYear().toString();
      }

      setFormData({
        ...customerDetail,
        assigned_abroad_counseling: getAssignedAdmin("Abroad Counseling"),
        assigned_career_counseling: getAssignedAdmin("Career Counseling"),
        assigned_test_preparation: getAssignedAdmin("Test Preparation"),
        assigned_visa: getAssignedAdmin("Other Services"),
        assigned_profile_building: getAssignedAdmin("Profile Building"),
        intakeMonth,
        intakeYear,
      });
    }
  }, [customerDetail]);

  const getCustom = async (id) => {
    const response = await getCustomer(id);
    dispatch(setCustomerDetail(response.data));
  };

  useEffect(() => {
    getCustom(location.pathname.split("/")[3]);
  }, [location.pathname]);

  const formatYMD = (year, monthIndex) => {
    const mm = String(monthIndex + 1).padStart(2, "0");
    return `${year}-${mm}-01`;
  };

  const handleMonthChange = (selectedOption) => {
    const month = selectedOption ? selectedOption.value : "";

    setFormData((prev) => {
      const next = { ...prev, intakeMonth: month };

      // if both exist -> set intake safely
      if (month && prev.intakeYear) {
        const monthIndex = monthOptions.findIndex((m) => m.value === month);
        next.intake =
          monthIndex !== -1 ? formatYMD(prev.intakeYear, monthIndex) : null;
      } else {
        next.intake = null;
      }

      return next;
    });

    if (validationError) setValidationError("");
  };

  const handleYearChange = (selectedOption) => {
    const year = selectedOption ? selectedOption.value : "";

    setFormData((prev) => {
      const next = { ...prev, intakeYear: year };

      // if both exist -> set intake safely
      if (prev.intakeMonth && year) {
        const monthIndex = monthOptions.findIndex(
          (m) => m.value === prev.intakeMonth
        );
        next.intake = monthIndex !== -1 ? formatYMD(year, monthIndex) : null;
      } else {
        next.intake = null;
      }

      return next;
    });

    if (validationError) setValidationError("");
  };

  // const handleMonthChange = (selectedOption) => {
  //   const month = selectedOption ? selectedOption.value : "";
  //   setFormData((prevState) => ({
  //     ...prevState,
  //     intakeMonth: month,
  //   }));
  //   updateIntake(month, formData.intakeYear);
  //   // Clear validation error when user makes changes
  //   if (validationError) setValidationError("");
  // };

  // const handleYearChange = (selectedOption) => {
  //   const year = selectedOption ? selectedOption.value : "";
  //   setFormData((prevState) => ({
  //     ...prevState,
  //     intakeYear: year,
  //   }));
  //   updateIntake(formData.intakeMonth, year);
  //   // Clear validation error when user makes changes
  //   if (validationError) setValidationError("");
  // };

  const updateIntake = (month, year) => {
    if (month && year) {
      // Convert month name to month number (0-11 for JS Date)
      const monthIndex = monthOptions.findIndex((m) => m.value === month);

      if (monthIndex !== -1) {
        // Create date and format as YYYY-MM-DD
        const date = new Date(year, monthIndex, 1);
        const formattedDate = date.toISOString().split("T")[0];

        setFormData((prevState) => ({
          ...prevState,
          intakeMonth: month,
          intakeYear: year,
          intake: formattedDate, // Stores date as YYYY-MM-DD
        }));
      }
    } else {
      // Either one or both are empty - clear the intake field
      setFormData((prevState) => ({
        ...prevState,
        intakeMonth: month,
        intakeYear: year,
        intake: null, // Send null instead of empty string
      }));
    }
  };

  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from(
    { length: currentYear - currentYear + 11 }, // Generate 11 years
    (_, index) => {
      const year = currentYear + index;
      return { value: year.toString(), label: year.toString() };
    }
  );

  const servicesOptions = [
    ...services.abroad_counselling_list.map((item) => ({
      value: item.service_name,
      label: item.service_name,
    })),
    ...services.test_prep_list.map((item) => ({
      value: item.service_name,
      label: item.service_name,
    })),
    ...services.career_counselling_list.map((item) => ({
      value: item.service_name,
      label: item.service_name,
    })),
    ...services.other_services_list.map((item) => ({
      value: item.service_name,
      label: item.service_name,
    })),
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    // Clear validation error when user makes changes
    if (validationError) setValidationError("");
  };

  const [predefinedCountries, setPredefinedCountries] = useState([
    { value: "USA", label: "USA" },
    { value: "UK", label: "UK" },
    { value: "Canada", label: "Canada" },
    { value: "Australia", label: "Australia" },
    { value: "New Zealand", label: "New Zealand" },
    { value: "Dubai", label: "Dubai" },
    { value: "Ireland", label: "Ireland" },
    { value: "Germany", label: "Germany" },
    { value: "France", label: "France" },
    { value: "Sweden", label: "Sweden" },
    { value: "Singapore", label: "Singapore" },
    { value: "Other", label: "Other" },
  ]);

  const handleCountryChange = (selectedOptions) => {
    const selectedCountries = selectedOptions.map((option) => option.value);
    setFormData((prevState) => ({
      ...prevState,
      preferred_countries: selectedCountries,
      showOtherInput: selectedOptions.some(
        (option) => option.value === "Other"
      ),
    }));
  };

  const handleOtherCountry = (e) => {
    const otherCountry = e.target.value;
    setFormData((prevState) => ({
      ...prevState,
      otherCountry: otherCountry,
    }));
  };

  const coreServiceNames = ((customerDetail && customerDetail.services) || [])
    .map((service) => service.coreservice_name)
    .filter((name) => name); // Filter out null values

  const handleAddOtherCountry = () => {
    if (formData.otherCountry) {
      const newCountry = {
        value: formData.otherCountry,
        label: formData.otherCountry,
      };

      // Add the new country to the predefinedCountries list
      setPredefinedCountries((prevCountries) => [
        ...prevCountries.filter((country) => country.value !== "Other"), // Remove the placeholder "Other"
        newCountry,
        { value: "Other", label: "Other" }, // Re-add the "Other" option
      ]);

      // Add the new country to the selected countries
      setFormData((prevState) => ({
        ...prevState,
        preferred_countries: [
          ...(prevState.preferred_countries || []),
          formData.otherCountry,
        ],
        otherCountry: "",
      }));
    }
  };
  const handleRowClick = async (id) => {
    try {
      const response = await getCustomer(id);
      dispatch(setCustomerDetail(response.data));
    } catch (error) {
      console.error("Failed to fetch customer detail:", error);
    }
  };
  const isIntakeIncomplete = (() => {
    const hasMonth = formData.intakeMonth && formData.intakeMonth.trim() !== "";
    const hasYear = formData.intakeYear && formData.intakeYear.trim() !== "";

    // Incomplete if one is filled but not the other
    return (hasMonth && !hasYear) || (!hasMonth && hasYear);
  })();

  // Validation function for intake
  // Validation function for intake
  const validateIntake = () => {
    const hasMonth = formData.intakeMonth && formData.intakeMonth.trim() !== "";
    const hasYear = formData.intakeYear && formData.intakeYear.trim() !== "";

    // Both must be filled
    if (!hasMonth && !hasYear) {
      setValidationError("Please select both intake month and year");
      return false;
    }
    if (hasMonth && !hasYear) {
      setValidationError("Please select intake year");
      return false;
    }
    if (hasYear && !hasMonth) {
      setValidationError("Please select intake month");
      return false;
    }

    // Both filled is valid
    return true;
  };

  const toggleEditMode = async () => {
    if (isEditing) {
      // Validate intake before saving
      if (!validateIntake()) {
        return; // Don't proceed with save if validation fails
      }

      // Save functionality
      setIsSaving(true);
      setValidationError(""); // Clear any previous errors

      const updatedData = {};
      Object.keys(formData).forEach((key) => {
        if (formData[key] !== customerDetail[key]) {
          updatedData[key] = formData[key];
        }
      });

      try {
        await updateCustomer(formData.id, updatedData);
        handleRowClick(formData.id);
        setIsEditing(false);
      } catch (err) {
        console.error("Error updating customer:", err);
        setValidationError("Failed to update customer. Please try again.");
      } finally {
        setIsSaving(false);
      }
    } else {
      setIsEditing(true);
      setValidationError(""); // Clear validation error when entering edit mode
    }
  };

  const selectStyles = {
    // Custom styles for Select component
    control: (provided, state) => ({
      ...provided,
      borderColor:
        validationError &&
        (state.selectProps.name === "intakeMonth" ||
          state.selectProps.name === "intakeYear")
          ? "#ef4444"
          : "#e2e8f0",
      boxShadow: "none",
      "&:hover": {
        borderColor:
          validationError &&
          (state.selectProps.name === "intakeMonth" ||
            state.selectProps.name === "intakeYear")
            ? "#ef4444"
            : "#cbd5e0",
      },
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 30, // Ensure dropdowns appear above other content
    }),
  };
  const intakeErrorMessage = isIntakeIncomplete
    ? "Please select both intake month and year"
    : "";
  return (
    <div className="p-2 sm:p-4 bg-white rounded-lg h-full w-full mx-auto">
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center border-b border-gray-300 pb-4 mb-4">
        <h2 className="text-xl sm:text-2xl font-semibold mb-2 sm:mb-0">
          Profile
        </h2>
        <button
          onClick={toggleEditMode}
          className="bg-purple-600 text-white px-4 py-2 font-semibold text-sm rounded-lg hover:bg-purple-700 active:bg-purple-800 focus:outline-none focus:ring-2 focus:ring-purple-400 focus:ring-offset-2 transition-transform transform active:scale-95 flex items-center justify-center gap-2 w-full sm:w-auto disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={isSaving || (isEditing && isIntakeIncomplete)}
        >
          {isSaving ? (
            <>
              <svg
                className="animate-spin h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v4l3-3m-3 3L8 4"
                ></path>
              </svg>
              Saving...
            </>
          ) : isEditing ? (
            "Save"
          ) : (
            "Edit"
          )}
        </button>
      </div>

      {/* Validation Error Message */}
      {validationError && (
        <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg flex items-start">
          <svg
            className="w-5 h-5 text-red-500 mt-0.5 mr-2 flex-shrink-0"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
              clipRule="evenodd"
            />
          </svg>
          <span className="text-sm text-red-700">{validationError}</span>
        </div>
      )}

      <h3 className="text-lg font-semibold mb-4">Customer Details</h3>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mb-6">
        {/* Admin Assignment Fields */}
        <div>
          <label className="block text-sm text-gray-600 mb-2">Assigned</label>
          {isEditing ? (
            <select
              name="assigned_to"
              value={formData.assigned_to}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-600"
            >
              <option value="">Select an option</option>
              {admins
                .filter((admin) => admin.role === "admin")
                .map((admin) => (
                  <option key={admin.admin_id} value={admin.admin_id}>
                    {admin.username}
                  </option>
                ))}
            </select>
          ) : (
            <p className="w-full px-4 py-2 border rounded-md overflow-x-auto whitespace-nowrap">
              {admins.find(
                (admin) =>
                  parseInt(admin.admin_id) === parseInt(formData.assigned_to)
              )?.username || "Not Provided"}
            </p>
          )}
        </div>

        {/* Assigned Content Writer */}
        <div>
          <label className="block text-sm text-gray-600 mb-2">
            Assigned Content Writer
          </label>
          {isEditing ? (
            <select
              name="assigned_content_writer"
              value={formData.assigned_content_writer}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-600"
            >
              <option value="">Select an option</option>
              {admins
                .filter((admin) => admin.role === "admin")
                .map((admin) => (
                  <option key={admin.admin_id} value={admin.admin_id}>
                    {admin.username}
                  </option>
                ))}
            </select>
          ) : (
            <p className="w-full px-4 py-2 border rounded-md overflow-x-auto whitespace-nowrap">
              {admins.find(
                (admin) =>
                  parseInt(admin.admin_id) ===
                  parseInt(formData.assigned_content_writer)
              )?.username || "Not Provided"}
            </p>
          )}
        </div>

        {/* Assigned Application Manager */}
        <div>
          <label className="block text-sm text-gray-600 mb-2">
            Assigned Application Manager
          </label>
          {isEditing ? (
            <select
              name="assigned_application_manager"
              value={formData.assigned_application_manager}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-600"
            >
              <option value="">Select an option</option>
              {admins
                .filter((admin) => admin.role === "admin")
                .map((admin) => (
                  <option key={admin.admin_id} value={admin.admin_id}>
                    {admin.username}
                  </option>
                ))}
            </select>
          ) : (
            <p className="w-full px-4 py-2 border rounded-md overflow-x-auto whitespace-nowrap">
              {admins.find(
                (admin) =>
                  parseInt(admin.admin_id) ===
                  parseInt(formData.assigned_application_manager)
              )?.username || "Not Provided"}
            </p>
          )}
        </div>

        {/* Assigned Visa Manager */}
        <div>
          <label className="block text-sm text-gray-600 mb-2">
            Assigned Visa Manager
          </label>
          {isEditing ? (
            <select
              name="assigned_visa_manager"
              value={formData.assigned_visa_manager}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-600"
            >
              <option value="">Select an option</option>
              {admins
                .filter((admin) => admin.role === "admin")
                .map((admin) => (
                  <option key={admin.admin_id} value={admin.admin_id}>
                    {admin.username}
                  </option>
                ))}
            </select>
          ) : (
            <p className="w-full px-4 py-2 border rounded-md overflow-x-auto whitespace-nowrap">
              {admins.find(
                (admin) =>
                  parseInt(admin.admin_id) ===
                  parseInt(formData.assigned_visa_manager)
              )?.username || "Not Provided"}
            </p>
          )}
        </div>

        {/* Assigned Loan Manager */}
        <div>
          <label className="block text-sm text-gray-600 mb-2">
            Assigned Loan Manager
          </label>
          {isEditing ? (
            <select
              name="assigned_loan_manager"
              value={formData.assigned_loan_manager}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-600"
            >
              <option value="">Select an option</option>
              {admins
                .filter((admin) => admin.role === "admin")
                .map((admin) => (
                  <option key={admin.admin_id} value={admin.admin_id}>
                    {admin.username}
                  </option>
                ))}
            </select>
          ) : (
            <p className="w-full px-4 py-2 border rounded-md overflow-x-auto whitespace-nowrap">
              {admins.find(
                (admin) =>
                  parseInt(admin.admin_id) ===
                  parseInt(formData.assigned_loan_manager)
              )?.username || "Not Provided"}
            </p>
          )}
        </div>

        {/* Assigned Career Counseling */}
        <div>
          <label className="block text-sm text-gray-600 mb-2">
            Assigned Career Counseling
          </label>
          {isEditing ? (
            <select
              name="assigned_career_counseling"
              value={formData.assigned_career_counseling || ""}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-600"
            >
              <option value="">Select an option</option>
              {admins
                .filter((admin) => admin.role === "admin")
                .map((admin) => (
                  <option key={admin.admin_id} value={admin.admin_id}>
                    {admin.username}
                  </option>
                ))}
            </select>
          ) : (
            <p className="w-full px-4 py-2 border rounded-md overflow-x-auto whitespace-nowrap">
              {admins.find(
                (admin) =>
                  parseInt(admin.admin_id) ===
                  parseInt(formData.assigned_career_counseling)
              )?.username || "Not Provided"}
            </p>
          )}
        </div>

        {/* Assigned Test Preparation */}
        <div>
          <label className="block text-sm text-gray-600 mb-2">
            Assigned Test Preparation
          </label>
          {isEditing ? (
            <select
              name="assigned_test_preparation"
              value={formData.assigned_test_preparation || ""}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-600"
            >
              <option value="">Select an option</option>
              {admins
                .filter((admin) => admin.role === "admin")
                .map((admin) => (
                  <option key={admin.admin_id} value={admin.admin_id}>
                    {admin.username}
                  </option>
                ))}
            </select>
          ) : (
            <p className="w-full px-4 py-2 border rounded-md overflow-x-auto whitespace-nowrap">
              {admins.find(
                (admin) =>
                  parseInt(admin.admin_id) ===
                  parseInt(formData.assigned_test_preparation)
              )?.username || "Not Provided"}
            </p>
          )}
        </div>

        {/* Assigned Visa */}
        <div>
          <label className="block text-sm text-gray-600 mb-2">
            Assigned Visa
          </label>
          {isEditing ? (
            <select
              name="assigned_visa"
              value={formData.assigned_visa || ""}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-600"
            >
              <option value="">Select an option</option>
              {admins
                .filter((admin) => admin.role === "admin")
                .map((admin) => (
                  <option key={admin.admin_id} value={admin.admin_id}>
                    {admin.username}
                  </option>
                ))}
            </select>
          ) : (
            <p className="w-full px-4 py-2 border rounded-md overflow-x-auto whitespace-nowrap">
              {admins.find(
                (admin) =>
                  parseInt(admin.admin_id) === parseInt(formData.assigned_visa)
              )?.username || "Not Provided"}
            </p>
          )}
        </div>

        {/* Assigned Profile Building */}
        <div>
          <label className="block text-sm text-gray-600 mb-2">
            Assigned Profile Building
          </label>
          {isEditing ? (
            <select
              name="assigned_profile_building"
              value={formData.assigned_profile_building || ""}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-600"
            >
              <option value="">Select an option</option>
              {admins
                .filter((admin) => admin.role === "admin")
                .map((admin) => (
                  <option key={admin.admin_id} value={admin.admin_id}>
                    {admin.username}
                  </option>
                ))}
            </select>
          ) : (
            <p className="w-full px-4 py-2 border rounded-md overflow-x-auto whitespace-nowrap">
              {admins.find(
                (admin) =>
                  parseInt(admin.admin_id) ===
                  parseInt(formData.assigned_profile_building)
              )?.username || "Not Provided"}
            </p>
          )}
        </div>

        {/* Customer Name */}
        <div>
          <label className="block text-sm text-gray-600 mb-2">
            Customer Name
          </label>
          {isEditing ? (
            <input
              type="text"
              name="name"
              value={formData.name || ""}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-600"
            />
          ) : (
            <p className="w-full px-4 py-2 border rounded-md break-words">
              {formData.name || "Not Provided"}
            </p>
          )}
        </div>

        {/* Intake */}
        {/* Intake */}
        <div>
          <label className="block text-sm text-gray-600 mb-2">
            Intake
            {isEditing && (
              <span className="text-xs text-gray-500 ml-2">
                (Both month and year required)
              </span>
            )}
          </label>

          {isEditing ? (
            <>
              <div className="flex flex-col sm:flex-row sm:space-x-4 space-y-2 sm:space-y-0">
                <div className="w-full sm:w-1/2">
                  <Select
                    name="intakeMonth"
                    options={monthOptions}
                    onChange={handleMonthChange}
                    value={monthOptions.find(
                      (option) => option.value === formData.intakeMonth
                    )}
                    isSearchable
                    isClearable
                    placeholder="Month"
                    styles={selectStyles}
                  />
                </div>

                <div className="w-full sm:w-1/2">
                  <Select
                    name="intakeYear"
                    options={yearOptions}
                    onChange={handleYearChange}
                    value={yearOptions.find(
                      (option) => option.value === formData.intakeYear
                    )}
                    isSearchable
                    isClearable
                    placeholder="Year"
                    styles={selectStyles}
                  />
                </div>
              </div>

              {/* 🔴 Inline Error */}
              {isIntakeIncomplete && (
                <p className="mt-1 text-sm text-red-600">
                  Please select both intake month and year
                </p>
              )}
            </>
          ) : (
            <p className="w-full px-4 py-2 border rounded-md">
              {formData.intake || "N/A"}
            </p>
          )}
        </div>

        {/* Phone */}
        <div>
          <label className="block text-sm text-gray-600 mb-2">Phone</label>
          {isEditing ? (
            <input
              type="text"
              name="phone"
              value={formData.phone || ""}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-600"
            />
          ) : (
            <p className="w-full px-4 py-2 border rounded-md">
              {formData.phone || "N/A"}
            </p>
          )}
        </div>

        {/* Intended Degree */}
        <div>
          <label className="block text-sm text-gray-600 mb-2">
            Intended Degree
          </label>
          {isEditing ? (
            <select
              name="intended_degree"
              value={formData.intended_degree || ""}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-600"
            >
              <option value="" disabled>
                Select Degree
              </option>
              <option value="Undergraduate/Bachelors">
                Undergraduate/Bachelors
              </option>
              <option value="PG Diploma">PG Diploma</option>
              <option value="Masters">Masters</option>
              <option value="MBA">MBA</option>
              <option value="PhD">PhD</option>
            </select>
          ) : (
            <p className="w-full px-4 py-2 border rounded-md">
              {formData.intended_degree || "N/A"}
            </p>
          )}
        </div>

        {/* Countries */}
        <div>
          <label className="block text-sm text-gray-600 mb-2">Countries</label>
          {isEditing ? (
            <Select
              isMulti
              options={predefinedCountries}
              value={predefinedCountries.filter((country) =>
                (formData.preferred_countries || []).includes(country.value)
              )}
              onChange={handleCountryChange}
              className="w-full"
              styles={selectStyles}
            />
          ) : (
            <p className="w-full px-4 py-2 border rounded-md break-words">
              {(formData.preferred_countries || []).join(", ") || "N/A"}
            </p>
          )}
        </div>

        {/* Specify Other Country */}
        {formData.preferred_countries &&
          formData.preferred_countries.includes("Other") &&
          isEditing && (
            <div className="col-span-1 sm:col-span-2">
              <label className="block text-sm text-gray-600 mb-2">
                Specify Country
              </label>
              <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-4">
                <input
                  type="text"
                  name="otherCountry"
                  value={formData.otherCountry || ""}
                  onChange={handleOtherCountry}
                  className="w-full sm:w-2/3 px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-600"
                  placeholder="Enter country name"
                />
                <button
                  type="button"
                  className="w-full sm:w-1/3 bg-purple-600 text-white px-4 py-2 rounded-md hover:bg-purple-700 transition-colors"
                  onClick={handleAddOtherCountry}
                >
                  Add Country
                </button>
              </div>
            </div>
          )}

        {/* Intended Course */}
        <div>
          <label className="block text-sm text-gray-600 mb-2">
            Intended Course
          </label>
          {isEditing ? (
            <input
              type="text"
              name="intended_course"
              value={formData.intended_course || ""}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-600"
            />
          ) : (
            <p className="w-full px-4 py-2 border rounded-md break-words">
              {formData.intended_course || "N/A"}
            </p>
          )}
        </div>

        {/* Core Services */}
        <div>
          <label className="block text-sm text-gray-600 mb-2">
            Core Services
          </label>
          <p className="w-full px-4 py-2 border rounded-md break-words">
            {coreServiceNames.length > 0 ? coreServiceNames.join(", ") : "N/A"}
          </p>
        </div>

        {/* Service Taken */}
        <div>
          <label className="block text-sm text-gray-600 mb-2">
            Service Taken
          </label>
          {isEditing ? (
            <Select
              isMulti
              options={servicesOptions}
              value={servicesOptions.filter((option) =>
                (formData.subservice_name || []).includes(option.value)
              )}
              onChange={(selectedOptions) => {
                const selectedServices = selectedOptions.map(
                  (option) => option.value
                );
                setFormData((prevState) => ({
                  ...prevState,
                  subservice_name: selectedServices,
                }));
              }}
              className="w-full"
              styles={selectStyles}
            />
          ) : (
            <p className="w-full px-4 py-2 border rounded-md break-words">
              {(formData.subservice_name || []).join(", ") || "N/A"}
            </p>
          )}
        </div>

        {/* Status */}
        <div>
          <label className="block text-sm text-gray-600 mb-2">Status</label>
          {isEditing ? (
            <textarea
              name="status"
              value={formData.status || ""}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-600"
              rows="2"
            ></textarea>
          ) : (
            <p className="w-full px-4 py-2 border rounded-md break-words">
              {formData.status || "N/A"}
            </p>
          )}
        </div>

        {/* Branch */}
        <div>
          <label className="block text-sm text-gray-600 mb-2">Branch</label>
          {isEditing ? (
            <select
              name="branch"
              value={formData.branch || ""}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-600"
            >
              <option value="">Select an option</option>
              <option value="Vidyavihar">Vidyavihar</option>
              <option value="Andheri">Andheri</option>
            </select>
          ) : (
            <p className="w-full px-4 py-2 border rounded-md">
              {formData.branch || "N/A"}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export default CustomerProfileData;
